import { Content_Block } from "../ContentBlock";

export class TextBlock extends Content_Block{
    constructor(){
        super("text");
        this.content = "";
    }
}